/*
 *  TTTech nerve-management-system
 *  Copyright(c) 2025. TTTech Industrial Automation AG.
 *
 *  ALL RIGHTS RESERVED.
 *
 *  Usage of this software, including source code, netlists, documentation,
 *  is subject to restrictions and conditions of the applicable license
 *  agreement with TTTech Industrial Automation AG or its affiliates.
 *
 *  All trademarks used are the property of their respective owners.
 *
 *  TTTech Industrial Automation AG and its affiliates do not assume any liability
 *  arising out of the application or use of any product described or shown
 *  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
 *  make changes, at any time, in order to improve reliability, function or
 *  design.
 *
 *  Contact Information:
 *  support@tttech-industrial.com
 *
 *  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
 *
 */

import i18n from '@/i18n';

export default class BackupInfoModel {
  /**
   * Creates an instance of BackupInfoModel.
   * @param {Object} data - BackupInfoModel
   * @class BackupInfoModel
   * @property {string} action - Backup action - import or export
   * @property {string} status - status of backup
   * @property {string} backupName - Name of the backup
   * @property {string} creationInitiatedAt - Date and time when the backup was initiated
   * @property {string} errorMsg - Reason why backup failed
   */
  constructor(data = {}) {
    this.action = data.action || '';
    this.status = data.status || '';
    if (data.action === 'export' && data.status === 'COMPLETED') {
      this.backupName = data.backupName || '';
    }
    this.creationInitiatedAt = data.creationInitiatedAt || '';
    if (data.status === 'FAILED') {
      this.errorMsg = (() => {
        try {
          const parsed = JSON.parse(data.errorMsg);
          return parsed?.errorCode ? i18n.t(`errorMessages.${parsed.errorCode}`) : data.errorMsg;
        } catch {
          return data.errorMsg;
        }
      })();
    }
  }
}
